<template>
  <input
    type="text"
    :value="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
    class="w-full rounded-full border-gray-300 h-8 focus:ring-transparent"
    :class="{ 'mt-2 mb-4': !noMargins }"
    :placeholder="$t('input.refine')"
  />
</template>

<script>
export default {
  props: {
    modelValue: [String, Number],
    noMargins: Boolean,
  },
}
</script>
